import { Map } from 'immutable';
import { createSelector } from 'reselect';

import {
  getCompanyOneTimeEventDone,
  getCurrentLocationTierName,
  getCurrentUserIsManagerial,
  getRolloutEnabled,
  getUserOneTimeEventDone,
} from 'selectors/session';

import {
  AnonDataState,
  DashboardBannerState,
  DashboardBannerType,
} from 'features/productGrowth/types';

import { getUrlParamValue } from 'util/urlParams';

import { TIER_NAMES } from '../tiers/constants';

export const selectShowC2CDialogFromURL = createSelector(
  getCurrentLocationTierName,
  getCurrentUserIsManagerial,
  (currentLocationTierName, currentUserIsManagerial) =>
    currentUserIsManagerial &&
    currentLocationTierName !== TIER_NAMES.BASIC &&
    getUrlParamValue('show-c2c') === 'true'
);

export const selectUploadDocumentPending = (state: any) =>
  state.get('productGrowth').uploadDocumentIsPending;

export const selectUploadDocumentSuccess = (state: any) =>
  state.get('productGrowth').uploadDocumentSuccess?.message?.status ===
  'success';

export const selectDashboardBannerRolloutEnabled = (state: any) =>
  getRolloutEnabled(state, 'productgrowth_lw_2025');

export const selectDashboardBannerState = (state: any): DashboardBannerState =>
  state.get('productGrowth').dashboardBanner;

export const selectDismissedDashboardBanner = (
  state: any,
  bannerType?: DashboardBannerType
) => {
  if (bannerType === 'hiring') {
    return getUserOneTimeEventDone(state, 'dismissed_hiring_dashboard_banner');
  }

  if (bannerType === 'scheduling') {
    return getUserOneTimeEventDone(
      state,
      'dismissed_scheduling_dashboard_banner'
    );
  }

  return false;
};

export const selectPayrollCrossSellPayrollSelected = (
  state: Map<string, any>
) => getCompanyOneTimeEventDone(state, 'payroll_cross_sell_payroll_selected');

export const selectAnonData = (state: Map<string, any>): AnonDataState | null =>
  state.get('productGrowth').anonData;
